import { useEffect } from 'react';

// Warm a lazy chunk once the browser is idle, so a later tab switch renders without a
// loading flash. Safari < 18 has no requestIdleCallback — fall back to a short timeout.
export function useIdlePrefetch(prefetch: () => void) {
    useEffect(() => {
        if (typeof window.requestIdleCallback === 'function') {
            const idleId = window.requestIdleCallback(prefetch);
            return () => window.cancelIdleCallback(idleId);
        }
        const timeoutId = window.setTimeout(prefetch, 2000);
        return () => window.clearTimeout(timeoutId);
    }, [prefetch]);
}
